module.exports = __webpack_public_path__ + "static/media/white-ico-confirm-modal.a700a473.svg";